import * as Types from '../constants/actionTypes';
const defaultState = {
    userPbiReports: [],
    pbiReportError: ''
}
export default (state = defaultState, action) => {
    switch (action.type) {

        case Types.PBI_REPORT_FETCH:
            return {
                ...state,
                reportData: action.data,
                pbiReportError: ''
            }
        case Types.USER_PBI_REPORTS:
            return {
                ...state,
                userPbiReports: action.data,
                pbiReportError: ''
            }
        case Types.PBI_REPORT_FETCH_ERROR:
            return {
                ...state,
                pbiReportError: action.message
            }
        default:
            return state
    }
}
